import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TempusLogo from '../../../../images/tempusLogo.svg';
import typography from '@tcl-boron-styles/typography/dist/index.module.css';
import { Button } from '@tcl-boron-prefabs/button';
import fetchHelper from '../../../utils';
import config from '../../../../config';
import { trackEvent } from '../../../api/Pendo';
import { Banner } from '@tcl-boron-prefabs/banner';
import { Form } from 'react-final-form';
import FormTextInput from '../../shared/form/FormTextInput';
import { email } from '../../shared/form/validators';
import { NavigationPath } from '../../../api/constants';

const ForgotPassword: React.FC = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onSubmit = async (data: Record<string, any>) => {
    setLoading(true);
    setError(false);

    try {
      await fetchHelper('/account/forgot-password', {
        method: 'POST',
        baseUrl: config.patientWebServiceBaseUrl,
        headerOverrides: {
          'Content-Type': 'application/json',
        },
        body: { email: data.email },
      });

      trackEvent('PasswordResetRequested');
      setSuccess(true);
    } catch (error) {
      trackEvent('PasswordResetFailed', {
        error: error instanceof Error ? error.message : 'Unknown error',
      });
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container direction="column" margin="auto" maxWidth="512px" gap="20px" padding="20px">
      <img src={TempusLogo} alt="Tempus Logo" style={{ maxHeight: '24px' }} />
      <Grid item alignSelf="center">
        <p className={typography.sectionHeader}>Forgot your password or first time logging in?</p>
      </Grid>
      <Grid item alignSelf="center" textAlign={'center'}>
        <p className={typography.body}>
          Enter your email address below and we will send you instructions to set your password and access your account.
        </p>
      </Grid>
      {error && <Banner status="error" message="An error occurred. Please try again." ariaLabel="Error occurred" />}
      {success && (
        <Banner
          status="success"
          message="Password reset instructions have been sent to your email!"
          ariaLabel="Success"
        />
      )}
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, valid }) => (
          <>
            <FormTextInput
              label="Email Address"
              name="email"
              data-testid="email-input"
              placeholder="Enter your email address"
              validate={email}
            />
            <Button
              buttonType="primary"
              onClick={handleSubmit}
              ariaLabel="Continue"
              loading={loading}
              disabled={success || !valid}
              data-testid="submit-button"
              data-pendo="password-reset-submit-button"
            >
              Send Password Reset Instructions
            </Button>
          </>
        )}
      />
      <Grid item alignSelf="center" textAlign={'center'}>
        <p className={typography.body}>
          Already have an account? Login{' '}
          <a href={NavigationPath.HOME} className={typography.link}>
            here
          </a>
          .
        </p>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
